import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import staticContent from '../assets/json/staticContent.json';

export const LanguageContext = React.createContext({
  language: 'en',
  changeLanguage: () => null,
  getContentLanguage: () => null
});

export const LanguageConsumer = LanguageContext.Consumer;

export class LanguageProvider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { language: 'en' };
    this.changeLanguage = this.changeLanguage.bind(this);
    this.getContentLanguage = this.getContentLanguage.bind(this);
  }

  getContentLanguage(key) {
    const { language } = this.state;
    return get(staticContent, [key, language]);
  }

  changeLanguage(type) {
    this.setState({
      language: type
    });
  }

  render() {
    const { language } = this.state;
    const { children } = this.props;

    return (
      <LanguageContext.Provider
        value={{
          language,
          changeLanguage: this.changeLanguage,
          getContentLanguage: this.getContentLanguage
        }}
      >
        {children}
      </LanguageContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/utils/LanguageContext.js